import { Link } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useLocale } from '../i18n';

export function PageLoader() {
  const { t } = useLocale();
  return (
    <div className="flex min-h-[70vh] items-center justify-center" role="status">
      <Loader2 className="size-6 animate-spin text-primary" />
      <span className="sr-only">{t.states.loading}</span>
    </div>
  );
}

export function PageError({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const { t } = useLocale();
  return (
    <div className="container-site flex min-h-[70vh] flex-col items-start justify-center pt-24">
      <p className="eyebrow">{t.states.error}</p>
      <h1 className="mt-3 text-5xl font-black tracking-[-0.005em]">{t.states.wrong}</h1>
      <p className="mt-4 max-w-md font-light text-graphite">
        {t.states.apiError ?? (error instanceof Error ? error.message : t.states.couldNotLoad)}
      </p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-8 h-12 rounded-lg bg-ink px-6 font-bold text-canvas hover:bg-primary"
        >
          {t.states.tryAgain}
        </button>
      )}
    </div>
  );
}

export function NotFoundPage() {
  const { t, to } = useLocale();
  return (
    <div className="container-site flex min-h-[80vh] flex-col justify-center pt-28 pb-16">
      <title>{t.states.notFoundTitle}</title>
      <meta name="robots" content="noindex" />
      <p className="text-[clamp(6rem,4rem+10vw,14rem)] leading-[0.8] font-black tracking-[-0.025em] text-primary">
        404
      </p>
      <h1 className="mt-6 text-4xl font-extralight tracking-[-0.005em] md:text-6xl">
        {t.states.notFound}
      </h1>
      <p className="mt-4 max-w-md font-light text-graphite">{t.states.notFoundText}</p>
      <div className="mt-10 flex flex-wrap gap-3">
        <Link
          to={to('/')}
          className="inline-flex h-12 items-center rounded-lg bg-ink px-6 font-bold text-canvas hover:bg-primary"
        >
          {t.states.backHome}
        </Link>
        <Link
          to={to('/work')}
          className="inline-flex h-12 items-center rounded-lg border border-line px-6 font-light text-graphite hover:border-ink hover:text-ink"
        >
          {t.states.seeWork}
        </Link>
      </div>
    </div>
  );
}
